export default function PHP_ftp_nb_get() {
  return (
    <div>
      <h1>PHP_ftp_nb_get</h1>
    </div>
  );
}
